export default "__VITE_ASSET__Dm0u6Dkj__"